import axios from 'axios'

export default {
  namespaced: true,
  state: {
    date: '',
    timeslot: '',
    court: '',
    price: '',
    addons1: null,
    addons2: null
  },
  getters: {
    date(state) {
      return state.date
    },
    timeslot(state) {
      return state.timeslot
    },
    court(state) {
      return state.court
    },
    price(state) {
      return state.price
    },
    addons1(state) {
      return state.addons1
    },
    addons2(state) {
      return state.addons2
    },
  },
  mutations: {
    SET_DATE(state, value) {
      state.date = value
    },
    SET_TIMESLOT(state, value) {
      state.timeslot = value
    },
    SET_COURT(state, value) {
      state.court = value
    },
    SET_PRICE(state, value) {
      state.price = value
    },
    SET_ADDONS1(state, value) {
      // state.addons1.push(value)
      state.addons1 = value
    },
    SET_ADDONS2(state, value) {
      // state.addons2.push(value)
      state.addons2 = value
    },
  },
  actions: {
    date({ commit }, { set_date }) {
      commit('SET_DATE', set_date)
    },
    timeslot({ commit }, { set_timeslot }) {
      commit('SET_TIMESLOT', set_timeslot)
    },
    court({ commit }, { set_court }) {
      commit('SET_COURT', set_court)
    },
    price({ commit }, { set_price }) {
      commit('SET_PRICE', set_price)
    },
    addons1({ commit }, { set_addons1 }) {
      commit('SET_ADDONS1', set_addons1)
    },
    addons2({ commit }, { set_addons2 }) {
      commit('SET_ADDONS2', set_addons2)
    },
    reset_data({ commit }) {
      commit('SET_DATE', '')
      commit('SET_TIMESLOT', '')
      commit('SET_COURT', '')
      commit('SET_PRICE', '')
      commit('SET_ADDONS1', null)
      commit('SET_ADDONS2', null)
    }
  }
}